import { MouseSelectionStates } from "types";

import { mpcCompatibleHoverLegends } from "./mpcHighlights";

export function cumTimeHoverLegends(params: Partial<MouseSelectionStates>) {
  return mpcCompatibleHoverLegends(params);
}
